export const dinnerRolls = {
  id: "dinnerRolls",
  link: "/#/recipes/recipes/dinnerRolls",
  name: "Dinner Rolls",
  cuisine: "Azish",
  summary: "Fluffy and familiar rolls",
  inspiration: "Dinner Rolls",
  quantity: "12",
  time: "2 1/2 hours",
  notes:
    "These are just normal dinner rolls, exactly like you might find at an American dinner. The books just mention dinner rolls being present at the Azish palace, and if anyone is going to have access to exotic ingredients, it's the cooks at the Azish palace. So I decided to use wheat flour (from Shinovar) and plenty of dairy products. I used a mixture of wheat and white flour, but feel free to replace the wheat flour with white flour if you prefer.",
  quotes:
    "She reached up a hand and plucked a dinner roll off the table (Words of Radiance Interlude I-9)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/dinner-rolls-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "wheatFlour",
          display: "2 1/4 - 2 3/4 cups all-purpose flour, divided"
        },
        {
          item: "yeast",
          display: "1 packet instant yeast"
        },
        {
          item: "dairy",
          display: "1 cup milk"
        },
        {
          item: "honey",
          display: "2 tbsp honey"
        },
        {
          item: "dairy",
          display: "1/4 cup butter"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        },
        {
          item: "eggs",
          display: "1 egg"
        },
        {
          item: "wheatFlour",
          display: "1 cup whole wheat flour"
        }
      ]
    }
  ],
  steps: [
    "In the bowl of a stand mixer, combine 1 cup white flour and the yeast. Stir well, then set aside.",
    "In a saucepan, combine milk, honey, butter and salt. Heat just until warm, about 110 degrees Fahrenheit.",
    "Add liquid to flour mixture along with the egg. Mix on low for 30 seconds, then scrape the sides with a spoon or spatula. Mix on high for 3 minutes.",
    "Add whole wheat flour. Attach the dough hook attachment to the mixer. Turn the mixer to low, and start adding the remaining 1 1/4 to 1 3/4 cups white flour. Add just enough so that the dough pulls away from the sides of the bowl and forms a moderately stiff dough. Continue mixing on low for 5 more minutes, then mix on medium low for 3 minutes. At any point, if dough starts sticking to the sides again, add a little flour.",
    "Form the dough into a ball, place back in the mixer bowl, then cover and let rise for one hour until double in size.",
    "Punch down dough. Grease a 9x13 pan. Separate dough into 12 equal portions, and form each into a ball. To get a nice ball shape, roll into a rough ball, then grip it half way up between two fingers and pull and pinch the dough together. You can continue pulling with that pinching motion to form a nice dome on top with the messy bits at the bottom. Then pinch those together to seal, and place the ball seam side down in the pan. Cover and let rise 30 minutes until double.",
    "Preheat the oven to 350 degrees Fahrenheit. Bake for 20-25 minutes or until golden on top. Serve with jam or butter."
  ]
}
